const translation = {
  title: 'Explorați',
  sidebar: {
    discovery: 'Descoperire',
    chat: 'Chat',
    workspace: 'Spațiu de lucru',
    action: {
      pin: 'Fixați',
      unpin: 'Deblocați',
      rename: 'Redenumire',
      delete: 'Ștergeți',
    },
    delete: {
      title: 'Ștergeți aplicația',
      content: 'Sunteți sigur că doriți să ștergeți această aplicație?',
    },
  },
  apps: {
    title: 'Explorați aplicațiile Dify',
    description: 'Utilizați aceste aplicații model imediat sau personalizați-vă propria aplicație pe baza modelelor.',
    allCategories: 'Recomandate',
  },
  appCard: {
    addToWorkspace: 'Adăugați la spațiul de lucru',
    customize: 'Personalizați',
  },
  appCustomize: {
    title: 'Creați o aplicație din {{name}}',
    subTitle: 'Pictogramă și nume aplicație',
    nameRequired: 'Numele aplicației este obligatoriu',
  },
  category: {
    Assistant: 'Asistent',
    Writing: 'Scriere',
    Translate: 'Traducere',
    Programming: 'Programare',
    HR: 'Resurse Umane',
    Agent: 'Agent',
    Workflow: 'Flux de lucru',
    Entertainment: 'Divertisment',
  },
}

export default translation
